<script setup>
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { getLanguages } from '../composables/useLocale'
import { useLocaleStore } from '../stores/locale'

const localeStore = useLocaleStore()
const flags = import.meta.glob('@/assets/images/flags/*.svg', { eager: true, import: 'default' })
const languages = getLanguages()
const dropdown = ref(false)
const { locale } = useI18n()

languages.sort((x, y) => x.language.localeCompare(y.language, undefined, { numeric: true, sensitivity: 'base' }))

defineProps({
  bgClass: String,
  bgHoverClass: String
})

onMounted(() => {
  const [browserLocale] = navigator.language.split('-')
  localeStore.setLocale(localeStore.locale ? localeStore.locale : browserLocale)
  locale.value = localeStore.locale
})

const setLanguage = (value) => {
  localeStore.setLocale(value)
  locale.value = value
  dropdown.value = false
}
</script>

<template>
  <div class="relative w-full cursor-pointer" @click.stop="dropdown = !dropdown" :class="bgClass">
    <div class="flex items-center z-40 cursor-pointer">
      <div class="p-1">
        <i class="fal fa-fw fa-globe mr-4" />
      </div>
      <div>{{ languages.find((x) => x.locale === localeStore.locale)?.language }}</div>
      <div class="ml-auto text-xs text-gray-600">
        <i v-if="dropdown" class="fal fa-chevron-up" />
        <i v-else class="fal fa-chevron-down" />
      </div>
    </div>
    <div
      v-show="dropdown"
      class="absolute z-40 left-0 w-full top-full cursor-pointer overflow-hidden mt-2"
      :class="bgClass"
    >
      <div
        v-for="option in languages"
        :key="option.id"
        class="py-1 flex"
        :class="bgHoverClass"
        @click.stop="setLanguage(option.locale)"
      >
        <span class="flex items-center gap-3 px-2">
          <img class="w-4 ml-1" :src="flags[`/src/assets/images/flags/${option.locale}.svg`]" />
          <strong>{{ option.language }}</strong>
        </span>
      </div>
    </div>
    <div v-if="dropdown" class="fixed w-full h-full top-0 left-0 z-30 cursor-auto" @click.stop="dropdown = false" />
  </div>
</template>
